<div class="search-bar">
  <i matPrefix class="fas fa-search searchbar-icon"></i>
  <input [formControl]="searchCtrl" placeholder="Search">
</div>
